export enum MeasureTypeEnum {
  BASELINE = 'BASELINE',
  INFUSION_TEST = 'INFUSION_TEST',
}
